import { render, staticRenderFns } from "./phoneBanks.vue?vue&type=template&id=243e4894&scoped=true"
import script from "./phoneBanks.vue?vue&type=script&lang=js"
export * from "./phoneBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243e4894",
  null
  
)

export default component.exports